// src/redux/actions/timesheetActions.js

// =========================
// TYPES
// =========================
export const SET_TIMESHEET_LOADING = "SET_TIMESHEET_LOADING";
export const CLEAR_TIMESHEET_ERROR = "CLEAR_TIMESHEET_ERROR";

export const FETCH_TIMESHEETS_REQUEST = "FETCH_TIMESHEETS_REQUEST";
export const FETCH_TIMESHEETS_SUCCESS = "FETCH_TIMESHEETS_SUCCESS";
export const FETCH_TIMESHEETS_FAIL = "FETCH_TIMESHEETS_FAIL";

export const GET_TIMESHEET_REQUEST = "GET_TIMESHEET_REQUEST";
export const GET_TIMESHEET_SUCCESS = "GET_TIMESHEET_SUCCESS";
export const GET_TIMESHEET_FAIL = "GET_TIMESHEET_FAIL";

export const CREATE_TIMESHEET_REQUEST = "CREATE_TIMESHEET_REQUEST";
export const CREATE_TIMESHEET_SUCCESS = "CREATE_TIMESHEET_SUCCESS";
export const CREATE_TIMESHEET_FAIL = "CREATE_TIMESHEET_FAIL";

export const UPDATE_TIMESHEET_REQUEST = "UPDATE_TIMESHEET_REQUEST";
export const UPDATE_TIMESHEET_SUCCESS = "UPDATE_TIMESHEET_SUCCESS";
export const UPDATE_TIMESHEET_FAIL = "UPDATE_TIMESHEET_FAIL";

export const DELETE_TIMESHEET_REQUEST = "DELETE_TIMESHEET_REQUEST";
export const DELETE_TIMESHEET_SUCCESS = "DELETE_TIMESHEET_SUCCESS";
export const DELETE_TIMESHEET_FAIL = "DELETE_TIMESHEET_FAIL";

export const FETCH_TIMESHEET_DAYS_REQUEST = "FETCH_TIMESHEET_DAYS_REQUEST";
export const FETCH_TIMESHEET_DAYS_SUCCESS = "FETCH_TIMESHEET_DAYS_SUCCESS";
export const FETCH_TIMESHEET_DAYS_FAIL = "FETCH_TIMESHEET_DAYS_FAIL";

export const UPSERT_TIMESHEET_DAY_REQUEST = "UPSERT_TIMESHEET_DAY_REQUEST";
export const UPSERT_TIMESHEET_DAY_SUCCESS = "UPSERT_TIMESHEET_DAY_SUCCESS";
export const UPSERT_TIMESHEET_DAY_FAIL = "UPSERT_TIMESHEET_DAY_FAIL";

export const DELETE_TIMESHEET_DAY_REQUEST = "DELETE_TIMESHEET_DAY_REQUEST";
export const DELETE_TIMESHEET_DAY_SUCCESS = "DELETE_TIMESHEET_DAY_SUCCESS";
export const DELETE_TIMESHEET_DAY_FAIL = "DELETE_TIMESHEET_DAY_FAIL";

export const FETCH_TIMESHEET_OVERTIMES_REQUEST = "FETCH_TIMESHEET_OVERTIMES_REQUEST";
export const FETCH_TIMESHEET_OVERTIMES_SUCCESS = "FETCH_TIMESHEET_OVERTIMES_SUCCESS";
export const FETCH_TIMESHEET_OVERTIMES_FAIL    = "FETCH_TIMESHEET_OVERTIMES_FAIL";

export const UPSERT_TIMESHEET_OVERTIME_REQUEST = "UPSERT_TIMESHEET_OVERTIME_REQUEST";
export const UPSERT_TIMESHEET_OVERTIME_SUCCESS = "UPSERT_TIMESHEET_OVERTIME_SUCCESS";
export const UPSERT_TIMESHEET_OVERTIME_FAIL    = "UPSERT_TIMESHEET_OVERTIME_FAIL";

export const DELETE_TIMESHEET_OVERTIME_REQUEST = "DELETE_TIMESHEET_OVERTIME_REQUEST";
export const DELETE_TIMESHEET_OVERTIME_SUCCESS = "DELETE_TIMESHEET_OVERTIME_SUCCESS";
export const DELETE_TIMESHEET_OVERTIME_FAIL    = "DELETE_TIMESHEET_OVERTIME_FAIL";

// ===== Overtime Workflow =====
export const SUBMIT_OVERTIME_REQUEST = "SUBMIT_OVERTIME_REQUEST";
export const SUBMIT_OVERTIME_SUCCESS = "SUBMIT_OVERTIME_SUCCESS";
export const SUBMIT_OVERTIME_FAIL    = "SUBMIT_OVERTIME_FAIL";

export const FETCH_OVERTIME_MANAGER_INBOX_REQUEST = "FETCH_OVERTIME_MANAGER_INBOX_REQUEST";
export const FETCH_OVERTIME_MANAGER_INBOX_SUCCESS = "FETCH_OVERTIME_MANAGER_INBOX_SUCCESS";
export const FETCH_OVERTIME_MANAGER_INBOX_FAIL    = "FETCH_OVERTIME_MANAGER_INBOX_FAIL";

export const FETCH_OVERTIME_MANAGER_HISTORY_REQUEST = "FETCH_OVERTIME_MANAGER_HISTORY_REQUEST";
export const FETCH_OVERTIME_MANAGER_HISTORY_SUCCESS = "FETCH_OVERTIME_MANAGER_HISTORY_SUCCESS";
export const FETCH_OVERTIME_MANAGER_HISTORY_FAIL    = "FETCH_OVERTIME_MANAGER_HISTORY_FAIL";

export const FETCH_OVERTIME_ADMIN_INBOX_REQUEST = "FETCH_OVERTIME_ADMIN_INBOX_REQUEST";
export const FETCH_OVERTIME_ADMIN_INBOX_SUCCESS = "FETCH_OVERTIME_ADMIN_INBOX_SUCCESS";
export const FETCH_OVERTIME_ADMIN_INBOX_FAIL    = "FETCH_OVERTIME_ADMIN_INBOX_FAIL";

export const FETCH_OVERTIME_ADMIN_HISTORY_REQUEST = "FETCH_OVERTIME_ADMIN_HISTORY_REQUEST";
export const FETCH_OVERTIME_ADMIN_HISTORY_SUCCESS = "FETCH_OVERTIME_ADMIN_HISTORY_SUCCESS";
export const FETCH_OVERTIME_ADMIN_HISTORY_FAIL    = "FETCH_OVERTIME_ADMIN_HISTORY_FAIL";

export const MANAGER_OVERTIME_DECISION_REQUEST = "MANAGER_OVERTIME_DECISION_REQUEST";
export const MANAGER_OVERTIME_DECISION_SUCCESS = "MANAGER_OVERTIME_DECISION_SUCCESS";
export const MANAGER_OVERTIME_DECISION_FAIL    = "MANAGER_OVERTIME_DECISION_FAIL";

export const ADMIN_OVERTIME_DECISION_REQUEST = "ADMIN_OVERTIME_DECISION_REQUEST";
export const ADMIN_OVERTIME_DECISION_SUCCESS = "ADMIN_OVERTIME_DECISION_SUCCESS";
export const ADMIN_OVERTIME_DECISION_FAIL    = "ADMIN_OVERTIME_DECISION_FAIL";

// =========================
// HELPERS
// =========================
export const setTimesheetLoading = (loading) => ({
    type: SET_TIMESHEET_LOADING,
    payload: loading,
});

export const clearTimesheetError = () => ({
    type: CLEAR_TIMESHEET_ERROR,
});

// =========================
// TIMESHEETS (HEADER)
// =========================
export const fetchTimesheetsRequest = () => ({ type: FETCH_TIMESHEETS_REQUEST });
export const fetchTimesheetsSuccess = (data) => ({ type: FETCH_TIMESHEETS_SUCCESS, payload: data });
export const fetchTimesheetsFail = (error) => ({ type: FETCH_TIMESHEETS_FAIL, payload: error });

export const getTimesheetRequest = (id) => ({ type: GET_TIMESHEET_REQUEST, payload: id });
export const getTimesheetSuccess = (data) => ({ type: GET_TIMESHEET_SUCCESS, payload: data });
export const getTimesheetFail = (error) => ({ type: GET_TIMESHEET_FAIL, payload: error });

export const createTimesheetRequest = (payload, meta = {}) => ({ type: CREATE_TIMESHEET_REQUEST, payload, meta });
export const createTimesheetSuccess = (data) => ({ type: CREATE_TIMESHEET_SUCCESS, payload: data });
export const createTimesheetFail = (error) => ({ type: CREATE_TIMESHEET_FAIL, payload: error });

export const updateTimesheetRequest = (id, payload) => ({
    type: UPDATE_TIMESHEET_REQUEST,
    payload: { id, payload },
});
export const updateTimesheetSuccess = (data) => ({ type: UPDATE_TIMESHEET_SUCCESS, payload: data });
export const updateTimesheetFail = (error) => ({ type: UPDATE_TIMESHEET_FAIL, payload: error });

export const deleteTimesheetRequest = (id) => ({ type: DELETE_TIMESHEET_REQUEST, payload: id });
export const deleteTimesheetSuccess = (id) => ({ type: DELETE_TIMESHEET_SUCCESS, payload: id });
export const deleteTimesheetFail = (error) => ({ type: DELETE_TIMESHEET_FAIL, payload: error });

// =========================
// DAYS (LINES)
// =========================
export const fetchTimesheetDaysRequest = (timesheetId) => ({
    type: FETCH_TIMESHEET_DAYS_REQUEST,
    payload: timesheetId,
});
export const fetchTimesheetDaysSuccess = (timesheetId, days) => ({
    type: FETCH_TIMESHEET_DAYS_SUCCESS,
    payload: { timesheetId, days },
});
export const fetchTimesheetDaysFail = (error) => ({ type: FETCH_TIMESHEET_DAYS_FAIL, payload: error });

export const upsertTimesheetDayRequest = (payload) => ({
    type: UPSERT_TIMESHEET_DAY_REQUEST,
    payload, // {timesheetId, workDate, heures, commentaire?}
});
export const upsertTimesheetDaySuccess = (data) => ({
    type: UPSERT_TIMESHEET_DAY_SUCCESS,
    payload: data, // TimesheetDayResponseDTO
});
export const upsertTimesheetDayFail = (error) => ({ type: UPSERT_TIMESHEET_DAY_FAIL, payload: error });

export const deleteTimesheetDayRequest = (dayId, timesheetId) => ({
    type: DELETE_TIMESHEET_DAY_REQUEST,
    payload: { dayId, timesheetId },
});
export const deleteTimesheetDaySuccess = (dayId, timesheetId) => ({
    type: DELETE_TIMESHEET_DAY_SUCCESS,
    payload: { dayId, timesheetId },
});
export const deleteTimesheetDayFail = (error) => ({ type: DELETE_TIMESHEET_DAY_FAIL, payload: error });

// ===== Overtime =====
export const fetchTimesheetOvertimesRequest = (timesheetId) => ({
    type: FETCH_TIMESHEET_OVERTIMES_REQUEST,
    payload: timesheetId,
});
export const fetchTimesheetOvertimesSuccess = (timesheetId, overtimes) => ({
    type: FETCH_TIMESHEET_OVERTIMES_SUCCESS,
    payload: { timesheetId, overtimes },
});
export const fetchTimesheetOvertimesFail = (error) => ({
    type: FETCH_TIMESHEET_OVERTIMES_FAIL,
    payload: error,
});

export const upsertTimesheetOvertimeRequest = (payload, meta = {}) => ({
    type: UPSERT_TIMESHEET_OVERTIME_REQUEST,
    payload,
    meta,
});
export const upsertTimesheetOvertimeSuccess = (data) => ({
    type: UPSERT_TIMESHEET_OVERTIME_SUCCESS,
    payload: data,
});
export const upsertTimesheetOvertimeFail = (error) => ({
    type: UPSERT_TIMESHEET_OVERTIME_FAIL,
    payload: error,
});

export const deleteTimesheetOvertimeRequest = (overtimeId, timesheetId) => ({
    type: DELETE_TIMESHEET_OVERTIME_REQUEST,
    payload: { overtimeId, timesheetId },
});
export const deleteTimesheetOvertimeSuccess = (overtimeId, timesheetId) => ({
    type: DELETE_TIMESHEET_OVERTIME_SUCCESS,
    payload: { overtimeId, timesheetId },
});
export const deleteTimesheetOvertimeFail = (error) => ({
    type: DELETE_TIMESHEET_OVERTIME_FAIL,
    payload: error,
});

// ===== Overtime Workflow Action Creators =====
export const submitOvertimeRequest = (overtimeId, timesheetId) => ({
    type: SUBMIT_OVERTIME_REQUEST,
    payload: { overtimeId, timesheetId },
});
export const submitOvertimeSuccess = (data, timesheetId) => ({
    type: SUBMIT_OVERTIME_SUCCESS,
    payload: { data, timesheetId },
});
export const submitOvertimeFail = (error) => ({ type: SUBMIT_OVERTIME_FAIL, payload: error });

export const fetchOvertimeManagerInboxRequest = () => ({ type: FETCH_OVERTIME_MANAGER_INBOX_REQUEST });
export const fetchOvertimeManagerInboxSuccess = (data) => ({ type: FETCH_OVERTIME_MANAGER_INBOX_SUCCESS, payload: data });
export const fetchOvertimeManagerInboxFail = (error) => ({ type: FETCH_OVERTIME_MANAGER_INBOX_FAIL, payload: error });

export const fetchOvertimeManagerHistoryRequest = () => ({ type: FETCH_OVERTIME_MANAGER_HISTORY_REQUEST });
export const fetchOvertimeManagerHistorySuccess = (data) => ({ type: FETCH_OVERTIME_MANAGER_HISTORY_SUCCESS, payload: data });
export const fetchOvertimeManagerHistoryFail = (error) => ({ type: FETCH_OVERTIME_MANAGER_HISTORY_FAIL, payload: error });

export const fetchOvertimeAdminInboxRequest = () => ({ type: FETCH_OVERTIME_ADMIN_INBOX_REQUEST });
export const fetchOvertimeAdminInboxSuccess = (data) => ({ type: FETCH_OVERTIME_ADMIN_INBOX_SUCCESS, payload: data });
export const fetchOvertimeAdminInboxFail = (error) => ({ type: FETCH_OVERTIME_ADMIN_INBOX_FAIL, payload: error });

export const fetchOvertimeAdminHistoryRequest = () => ({ type: FETCH_OVERTIME_ADMIN_HISTORY_REQUEST });
export const fetchOvertimeAdminHistorySuccess = (data) => ({ type: FETCH_OVERTIME_ADMIN_HISTORY_SUCCESS, payload: data });
export const fetchOvertimeAdminHistoryFail = (error) => ({ type: FETCH_OVERTIME_ADMIN_HISTORY_FAIL, payload: error });

export const managerOvertimeDecisionRequest = (payload) => ({ type: MANAGER_OVERTIME_DECISION_REQUEST, payload });
export const managerOvertimeDecisionSuccess = (data, timesheetId) => ({ type: MANAGER_OVERTIME_DECISION_SUCCESS, payload: { data, timesheetId } });
export const managerOvertimeDecisionFail = (error) => ({ type: MANAGER_OVERTIME_DECISION_FAIL, payload: error });

export const adminOvertimeDecisionRequest = (payload) => ({ type: ADMIN_OVERTIME_DECISION_REQUEST, payload });
export const adminOvertimeDecisionSuccess = (data, timesheetId) => ({ type: ADMIN_OVERTIME_DECISION_SUCCESS, payload: { data, timesheetId } });
export const adminOvertimeDecisionFail = (error) => ({ type: ADMIN_OVERTIME_DECISION_FAIL, payload: error });
